import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { Box, Button, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Spinner } from "../../../components/Loading/Spinner";
import CreateIndicadorModal from "../../../components/Table/OAS/Objetivos/CreateIndicadorModal";
import DeleteIndicadoresModal from "../../../components/Table/OAS/Objetivos/DeleteIndicadoresModal";
import EditIndicadorModal from "../../../components/Table/OAS/Objetivos/EditIndicadorModal";
import HeaderIndicador from "../../../components/Table/OAS/Objetivos/HeaderIndicador";
import SingleObjDescription from "../../../components/Table/OAS/Objetivos/SingleObjDescription";
import { useSingleObjetivo } from "../../../context/SuperAdmin/OASContexts/SingleObjetivoContext";
import IndicadoresTable from "../../../components/Table/OAS/Objetivos/IndicadoresTable";

const SingleObjetivoPage = () => {
  const navigate = useNavigate();
  const { isLoadingInfo, objetivo } = useSingleObjetivo();
  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
        color: "#005559",
      }}
    >
      {/* Boton para volver */}
      <Grid item>
        <Button onClick={() => navigate(-1)} sx={{ color: "#336B87" }}>
          <ArrowBackOutlinedIcon />
          Volver
        </Button>
      </Grid>
      {isLoadingInfo ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <>
          {/* Título */}
          <Grid item>
            <Typography
              variant={"h4"}
              sx={{ color: "#005559", fontSize: "30px" }}
            >
              <b>Objetivo</b> | {objetivo?.id_objetivo}
            </Typography>
          </Grid>

          {/* Características del objetivo */}
          <Grid item>
            <SingleObjDescription />
          </Grid>

          {/* Linea divisoria */}
          <Grid item>
            <Box
              sx={{ height: "1px", width: 1, border: "1px solid #005559" }}
            ></Box>
          </Grid>

          {/* Subtítulo */}
          <Grid item>
            <Typography variant={"h5"}>
              <b>Indicadores</b>
            </Typography>
          </Grid>

          {/* Agregar o eliminar indicadores */}
          <Grid item>
            <HeaderIndicador />
          </Grid>

          {/* Tabla de indicadores */}
          <Grid item>
            <IndicadoresTable />
          </Grid>

          {/* Modal para confirmar eliminar indicadores del objetivo */}
          <Grid item>
            <DeleteIndicadoresModal />
          </Grid>

          {/* Modal para crear un indicador en un objetivo */}
          <Grid item>
            <CreateIndicadorModal />
          </Grid>

          {/* Modal para editar un indicador en un objetivo */}
          <Grid item>
            <EditIndicadorModal />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default SingleObjetivoPage;
